import {
    hasInternalAdminPrivileges,
    hasIsoOrganizationCapacity,
    hasMerchantOrganizationCapacity,
    hasOrganizationalAdminPrivileges,
    type RoleAssignmentPermissionContext,
} from '@anchorbase/pillar-sdk';

function hasDirectMerchantPaymentListPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return (
        hasInternalAdminPrivileges(activeRoleAssignment) ||
        hasMerchantOrganizationCapacity(activeRoleAssignment) ||
        (hasIsoOrganizationCapacity(activeRoleAssignment) &&
            hasOrganizationalAdminPrivileges(activeRoleAssignment))
    );
}

export function hasMerchantPaymentTransactionsPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return hasDirectMerchantPaymentListPage(activeRoleAssignment);
}

export function hasMerchantPaymentRequestsPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return hasDirectMerchantPaymentListPage(activeRoleAssignment);
}

export function hasMerchantCardVaultPage(
    activeRoleAssignment: RoleAssignmentPermissionContext | null
): boolean {
    return hasMerchantOrganizationCapacity(activeRoleAssignment);
}
